import {
  Component,
  ContentChild,
  Input,
  OnInit,
  TemplateRef,
} from "@angular/core";
import { FeeTableStructure, TradeFee } from "src/app/models/exchange-fees";
import { Coin } from "src/app/models/coin";
import { AuthService } from "src/app/api/auth.service";
import { Country } from "src/app/models/country";
import { Observable } from "rxjs";
import { Currency } from "src/app/models/currency";
import { CurrenciesService } from "src/app/api/currencies.service";

@Component({
    selector: "fees-trading",
    templateUrl: "./fees-trading.component.html",
    styleUrls: [
        "./fees-trading.component.scss",
        "../../fees-page/fees-page.component.scss",
    ],
    standalone: false
})
export class FeesTradingComponent implements OnInit {
  @Input() tradeFees: TradeFee[];
  @Input() last30DaysVolume: Coin;
  @Input() fiatCurrency: String;
  @Input() country: Country;
  displayFiatCurrencyPair: String[];

  @ContentChild("start") startButton: TemplateRef<void>;

  fiatDigitalFee: FeeTableStructure;
  digitalFee: FeeTableStructure;
  aedUsdtFee: FeeTableStructure;

  public currencies$: Observable<Currency[]> =
    this.currenciesService.getCrypto();

  constructor(
    private auth: AuthService,
    private currenciesService: CurrenciesService
  ) {}

  ngOnInit() {
    this.createFeeTableStructure();

    this.displayFiatCurrencyPair = ["-AED", "", ""];
    if (this.fiatCurrency !== "AED") {
      this.displayFiatCurrencyPair = [
        "-" + this.fiatCurrency,
        "/" + this.fiatCurrency,
        ", " + this.fiatCurrency,
      ];
    }
  }

  createFeeTableStructure() {
    this.fiatDigitalFee = {
      fee: this.getFeeByType("fiatDigitalPairs"),
      discountedFee: this.getFeeByType("fiatDigitalDiscountedPairs"),
      last30DaysVolume: this.last30DaysVolume,
    };

    this.digitalFee = {
      fee: this.getFeeByType("digitalPairs"),
      discountedFee: this.getFeeByType("digitalDiscountedPairs"),
      last30DaysVolume: this.last30DaysVolume,
    };

    this.aedUsdtFee = {
      fee: this.getFeeByType("usdtAedPair"),
      discountedFee: this.getFeeByType("usdtAedDiscountedPair"),
      last30DaysVolume: this.last30DaysVolume,
    };
  }

  getFeeByType(searchedType: string) {
    return this.tradeFees?.find(({ type }) => type === searchedType);
  }

  isLoggedIn() {
    return this.auth.getToken();
  }
}
